import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';

import { cx } from '../lib/cx';

export interface IconButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type' | 'aria-label'> {
  /** Required: an icon-only control must carry its own accessible name (a11y §8.6.15). */
  label: string;
  /** The (decorative, aria-hidden) icon. */
  children: ReactNode;
  /** `bare` drops the border/background (close ✕, chat reset). */
  tone?: 'default' | 'bare';
  type?: 'button' | 'submit' | 'reset';
}

/** Icon-only button, always labelled. */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { label, children, tone = 'default', type = 'button', className, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      aria-label={label}
      className={cx('ds-iconbtn', tone === 'bare' && 'ds-iconbtn--bare', className)}
      {...rest}
    >
      {children}
    </button>
  );
});
